module.exports = __webpack_public_path__ + "static/media/Electric_hum.d42bf39e.mp3";